"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var DOMTokenList = require("../generated/DOMTokenList");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var DefaultConstraintValidationImpl = require("../constraint-validation/DefaultConstraintValidation-impl").implementation;

var _require = require("../../utils"),
    mixin = _require.mixin;

var _require2 = require("../helpers/form-controls"),
    getLabelsForLabelable = _require2.getLabelsForLabelable,
    formOwner = _require2.formOwner;

var HTMLOutputElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLOutputElementImpl, _HTMLElementImpl);

  function HTMLOutputElementImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, HTMLOutputElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLOutputElementImpl).call(this, globalObject, args, privateData));
    _this._labels = null;
    _this._defaultValueOverride = null;
    _this._customValidityErrorMessage = "";
    return _this;
  }

  _createClass(HTMLOutputElementImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLOutputElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);

      if (name === "for" && this._htmlFor !== undefined) {
        this._htmlFor.attrModified();
      }
    }
  }, {
    key: "_barredFromConstraintValidationSpecialization",
    value: function _barredFromConstraintValidationSpecialization() {
      return true;
    }
  }, {
    key: "_formReset",
    value: function _formReset() {
      this.textContent = this.defaultValue;
      this._defaultValueOverride = null;
    }
  }, {
    key: "htmlFor",
    get: function get() {
      if (this._htmlFor === undefined) {
        this._htmlFor = DOMTokenList.createImpl(this._globalObject, [], {
          element: this,
          attributeLocalName: "for"
        });
      }

      return this._htmlFor;
    }
  }, {
    key: "type",
    get: function get() {
      return "output";
    }
  }, {
    key: "labels",
    get: function get() {
      return getLabelsForLabelable(this);
    }
  }, {
    key: "form",
    get: function get() {
      return formOwner(this);
    }
  }, {
    key: "value",
    get: function get() {
      return this.textContent;
    },
    set: function set(val) {
      this._defaultValueOverride = this.defaultValue;
      this.textContent = val;
    }
  }, {
    key: "defaultValue",
    get: function get() {
      if (this._defaultValueOverride !== null) {
        return this._defaultValueOverride;
      }

      return this.textContent;
    },
    set: function set(val) {
      if (this._defaultValueOverride === null) {
        this.textContent = val;
        return;
      }

      this._defaultValueOverride = val;
    }
  }]);

  return HTMLOutputElementImpl;
}(HTMLElementImpl);

mixin(HTMLOutputElementImpl.prototype, DefaultConstraintValidationImpl.prototype);
module.exports = {
  implementation: HTMLOutputElementImpl
};